import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CleverPushService } from '@zero/feature-clever-push/base';
import { BackendResponseStatus, IBackendResponse } from '@zero/shared/util-models';
import { PromotionService } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';
import { Observable, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SignUpService {
  public inputEmail: string;

  readonly #http = inject(HttpClient);
  readonly #promoService = inject(PromotionService);
  readonly #cleverPushService = inject(CleverPushService);

  public signUpOverBackend(email: string, password: string): Observable<IBackendResponse<unknown>> {
    const promoCode = this.#promoService.getAccountOpenReferenceId();
    const gaObj = this.#promoService.getGaParams();
    const platform = this.#cleverPushService.getPlatform();

    return from(this.#cleverPushService.getSubscriptionId()).pipe(
      switchMap((subscriptionId) =>
        this.#http
          .post<{ successful: boolean; error: string }>(`${environment.apihost}/api/user/signupuser`, {
            email,
            password,
            promoCode,
            gaObj,
            platform,
            subscriptionId,
          })
          .pipe(
            map((result) => {
              result.successful && this.#promoService.deletePromotionInfo();
              return { success: result.successful };
            }),
            catchError((e) =>
              of({
                success: false,
                err: e?.error,
                status: e?.status === 406 ? BackendResponseStatus.NOT_ACCEPTABLE : BackendResponseStatus.ERROR,
              }),
            ),
          ),
      ),
    );
  }

  public resendConfirmationMail(email: string): Observable<IBackendResponse<unknown>> {
    return this.#http
      .post<{ successful: boolean; error: string }>(`${environment.apihost}/api/user/resendConfirmationMail`, {
        email,
      })
      .pipe(
        map((result) => {
          if (result.successful === true) {
            return { success: true } as IBackendResponse<unknown>;
          } else {
            return {
              success: false,
              errorMessage: result.error,
            } as IBackendResponse<unknown>;
          }
        }),
        catchError((err) => {
          const retVal = { success: false } as IBackendResponse<unknown>;
          if (err instanceof HttpErrorResponse) {
            retVal.message = 'Fehler bei der Kommunikation mit dem Server. Versuche es später noch einmal.';
          }
          return of(retVal);
        }),
      );
  }
}
